module.exports = require('./src/index.js');



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-signature-pad/index.js